import { RootState } from "../index";
import Logger from "../../utils/logger";

const log = Logger.getLogger("store.persist")

export const loadState: () => Partial<RootState> | undefined = () => {
    try {
        const appState = localStorage.getItem("app_state")
        if (!appState) return undefined
        return JSON.parse(appState)
    } catch (e) {
        log.error("An error occurred while loading state", e)
        return undefined
    }
}
export const saveState = (state: Partial<RootState>) => {
    try {
        log.debug("Saving state ", state)
        const json = JSON.stringify(state)
        localStorage.setItem("app_state", json)
        return true
    } catch (e) {
        log.error("An error occurred while saving the application state", e)
        return false
    }
}